import { useQuery } from "@tanstack/react-query";
import * as API from "./index";

export const dashboardQueryFactory = {
  dashboard: "dashboard" as const,
  getNewsList: () => {
    return useQuery({
      queryKey: [dashboardQueryFactory.dashboard, "news"],
      queryFn: API.getNewsList,
    });
  },
  getNotificationList: () => {
    return useQuery({
      queryKey: [dashboardQueryFactory.dashboard, "notification"],
      queryFn: API.getNotificationList,
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
    });
  },
  getAttendanceStatistics: (params: { from: string; to: string }) => {
    return useQuery({
      queryKey: [dashboardQueryFactory.dashboard, "attendance", params],
      queryFn: () => API.getAttendanceStatistics(params),
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
    });
  },
};
